import script from "./ClaimStep.vue?vue&type=script&setup=true&lang=js"
export * from "./ClaimStep.vue?vue&type=script&setup=true&lang=js"

import "./ClaimStep.vue?vue&type=style&index=0&id=3d6f6d04&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3d6f6d04"]])

export default __exports__